import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section bg="white" data-id="element-141">
      <div className="text-center mb-12" data-id="element-142">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-143">
          Tener un cachorro no debería sentirse como una sentencia de insomnio
        </h2>
        <p className="text-xl text-navy/70 max-w-2xl mx-auto" data-id="element-144">
          Y mucho menos como la destrucción garantizada de tu propiedad.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-145">
        <div className="space-y-6" data-id="element-146">
          <p className="text-lg text-navy/80 leading-relaxed" data-id="element-147">
            El problema es que la mayoría de los consejos que encuentras en
            internet son fragmentos contradictorios. Un video te dice que lo
            ignores, otro que lo premies, y mientras tanto, tu sofá sigue siendo
            destruido.
          </p>

          <div className="bg-softred/10 border border-softred/20 p-6 rounded-xl" data-id="element-148">
            <h3 className="flex items-center gap-2 text-softred font-bold text-xl mb-3" data-id="element-149">
              <AlertCircle className="w-6 h-6" data-id="element-150" />
              El Ciclo de Reacción
            </h3>
            <p className="text-navy/80" data-id="element-151">
              Estás atrapado en un ciclo de "reacción": reaccionas al ladrido,
              reaccionas al accidente, reaccionas a la mordida.
            </p>
          </div>

          <p className="text-lg text-navy/80 leading-relaxed font-medium" data-id="element-152">
            Estás cansado, y tu cachorro está confundido. Sin un protocolo
            biológico claro, el caos solo va a empeorar.
          </p>
        </div>

        <div className="relative" data-id="element-153">
          <div className="aspect-square rounded-2xl bg-cream-dark overflow-hidden relative" data-id="element-154">
            {/* Abstract representation of chaos/confusion */}
            <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,#C0392B_0,transparent_50%),radial-gradient(circle_at_bottom_left,#1B2A4A_0,transparent_50%)]" data-id="element-155"></div>
            <div className="absolute inset-0 flex items-center justify-center p-8 text-center" data-id="element-156">
              <p className="font-serif text-2xl md:text-3xl text-navy/40 italic font-bold leading-tight" data-id="element-157">
                "Ignóralo"
                <br data-id="element-158" />
                <br data-id="element-159" />
                "Prémialo"
                <br data-id="element-160" />
                <br data-id="element-161" />
                "Castígalo"
                <br data-id="element-162" />
                <br data-id="element-163" />
                "Dale tiempo"
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}